import { PrecipApiResponse, PrecipApiSensor } from "../jefdaqLegacyApi/precip";
import { PrecipSensor_ } from "../models/Sensors";

import { isLengthUnit } from "../convert";
import notEmpty from "../shared/notEmpty";
import { precipIntervalSeconds } from "../shared/precipIntervals";

export const precipApiToSensors = (
  precipApiResponse: PrecipApiResponse
): PrecipSensor_[] => {
  const apiIntervals = precipApiResponse.meta.precipitationIntervalSeconds;
  if (JSON.stringify(apiIntervals) !== JSON.stringify(precipIntervalSeconds)) {
    throw new Error("Precipitation intervals do not match");
  }

  const apiSensorToPrecipSensor = (
    apiSensor: PrecipApiSensor
  ): PrecipSensor_ | undefined => {
    const type = "precip";

    const { site, name, source, lastReport, latitude, longitude } = apiSensor;
    const depths = apiSensor.precipitationDepthsInches.map((d) =>
      d === apiSensor.null ? undefined : d
    );


    const unit = apiSensor.unitShort.toLowerCase().trim();
    if (!isLengthUnit(unit)) {
      console.error("No compatible unit for precip sensor " + site);
      return undefined;
    }

    const sensor: PrecipSensor_ = {
      ...precipApiResponse.meta,
      type,
      id: site,   // not a typo, inconsistent
      site: name, // naming with legacy API
      latitude,
      longitude,
      lastReport: lastReport || undefined,
      unit,
      depths,
      owner: source
    };

    return sensor;
  };

  return precipApiResponse.data.map(apiSensorToPrecipSensor).filter(notEmpty);
};
